<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <clipPath id="master_svg0_107_1767">
        <rect x="24" y="24" width="24" height="24" rx="0" />
      </clipPath>
    </defs>
    <g
      transform="matrix(-1,0,0,-1,48,48)"
      clip-path="url(#master_svg0_107_1767)"
    >
      <g>
        <g>
          <path
            d="M29.293268,38.292519999999996L29.292893,38.29289Q29.152241,38.43355,29.076121,38.61732Q29,38.80109,29,39Q29,39.09849,29.019215,39.19509Q29.038429999999998,39.29169,29.076121,39.38268Q29.113812,39.47368,29.16853,39.55557Q29.223249,39.63746,29.292893,39.70711Q29.362537,39.77675,29.44443,39.83147Q29.526322,39.88619,29.617317,39.92388Q29.708311,39.96157,29.80491,39.98078Q29.9015086,40,30,40Q30.198912,40,30.382683,39.92388Q30.566455,39.84776,30.707107,39.70711L36,34.41421L41.2929,39.70711Q41.4335,39.84776,41.6173,39.92388Q41.8011,40,42,40Q42.0985,40,42.1951,39.98078Q42.2917,39.96157,42.3827,39.92388Q42.4737,39.88619,42.5556,39.83147Q42.6375,39.77675,42.7071,39.70711Q42.7767,39.63746,42.8315,39.55557Q42.8862,39.47368,42.9239,39.38268Q42.961600000000004,39.29169,42.9808,39.19509Q43,39.09849,43,39Q43,38.80109,42.9239,38.61732Q42.8478,38.43355,42.7071,38.29289L42.7061,38.29192L36.70711,32.292893Q36.56645,32.152241,36.38268,32.07612Q36.19891,32,36,32Q35.80109,32,35.61732,32.07612Q35.43355,32.152241,35.29289,32.292893L29.293268,38.292519999999996Z"
            fill-rule="evenodd"
            fill-opacity="1"
            style="mix-blend-mode:passthrough"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  components: {},
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
svg {
  fill: #444545;
}
</style>
